var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputNumBox"},[_c('el-input-number',_vm._b({on:{"change":_vm.change},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-input-number',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }